const o = {
  "chip--hover-actions": "_chip--hover-actions_1ms9s_1",
  "chip--hover-action": "_chip--hover-action_1ms9s_1"
};
export {
  o as default
};
//# sourceMappingURL=index.es5490.js.map
